<template>
    <!-- 旧的3大VIP开通的抽屉组件 -->
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="generalPagePaddingH">
                <header class="header paddingV16">
                    <div class="flexLayout">
                        <div style="width: 16px;"></div>
                        <div class="flexItem alignCenter grey10 fWeight600">
                            {{title}}{{vipType ? vipType.title : ''}}
                        </div>
                        <div style="width: 16px;">
                            <i class="icon closeIcon" @click="close()"></i>
                        </div>
                    </div>
                </header>
                <div class="body" style="margin-top: 10px; padding-bottom: 34px;">
                    <div class="relative">

                        <img class="w100p" src="vip/vip_course_year_price.png" v-show="vipType.type === 'course_vod'"/>
                        <img class="w100p" src="vip/vip_datum_year_price.png"  v-show="vipType.type === 'datum'"/>
                        <img class="w100p" src="vip/vip_atlas_year_price.png"  v-show="vipType.type === 'atlas_vip'"/>

                        <div class="alignC bold" :class="{gold : vipType.type === 'course_vod' ||
                            vipType.type === 'atlas', red : vipType.type === 'datum'}"
                             style="font-size: 20px; position: absolute;
                            top: 56px; width: 100%; left: 0">
                            ￥{{productData ? productData.price : '??'}}/年
                        </div>
                        <div class="alignC marginT8 textDelete f16" style="color: #B8C2D6; position: absolute;
                            top: 80px; width: 100%; left: 0">
                            ¥{{productData ? productData.originalPrice : '??'}}
                        </div>
                    </div>
                    <div class="font13r">
                        <label>
                            <input class="modernCheckbox" :class="{orangeCircleTickCheckbox : vipType.type === 'course_vod', redCircleTickCheckbox : vipType.type === 'datum'}"
                               type="checkbox" :checked="isAgreeServiceProtocol"
                               @change="changeAgreeServiceProtocol"/>
                            <span style="color: hsla(219, 9%, 39%, 1)">开通即同意</span>
                            <a style="color: hsla(2, 100%, 70%, 1);" :href="externalApp.oldShixun.baseUrl + 'html/txt.html?VIP=VIP'">
                                《师讯VIP会员服务协议》
                            </a>
                        </label>
                    </div>
                    <div class="marginT20">
                        <img class="w100p" src="vip/vip_svip_year_continute_button.png" v-show="vipType.type === 'super'"
                            @click="renewal()"/>
                        <img class="w100p" src="vip/vip_svip_year_continute_button.png" v-show="vipType.type === 'course_vod'"
                             @click="renewal()"/>
                        <img class="w100p" src="vip/vip_datum_year_continute_button.png" v-show="vipType.type === 'datum'"
                             @click="renewal()"/>
                        <img class="w100p" src="vip/vip_svip_year_continute_button.png" v-show="vipType.type === 'atlas_vip'"
                             @click="renewal()"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import payPart from '../shixunApp/payComp';

// data
import externalApp from '@data/externalApp';
import appHelper from "@util/appHelper";

const config = {
    apiConfig : {
        list : {
            url : "",
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        },
        get : {
            url : '',
            dataColumnMapping : {
                // userName : 'name'
            }
        },
        payVip : {
            url : "portal/v4/order/pay",
            method : 'post',
            idName : 'bizId',
            params : {
                orderBizType : 'OPEN_VIP',
                coinType : 'RMB'
            }
        },
        getPayStatus : {
            url : "portal/order/pay/update_order_status",
            method : 'post'
        },
    }
};

export default {
    name: "vipRenewalDrawer",
    extends : payPart,
    props : {
        title : {
            type : String,
            default : '续费'
        },
        productData : Object,
        isAgreeServiceProtocol : Boolean,
        vipType : {
            type : Object,
            default : () => {
                return {
                    type : '',
                    code : 0,
                    title : ''
                }
            }
        },
        highlightColor : {
            type : String,
            default : 'yellow'
        }
    },
    data() {
        return {
            visible : false,
            apiConfig : config.apiConfig,
            externalApp : externalApp
        }
    },
    methods : {
        open : function (){
            this.show();
        },
        close : function (){
            this.hide();
        },
        show : function (){
            this.visible = true;
        },
        hide : function (){
            this.visible = false;
        },
        changeAgreeServiceProtocol(event) {
            let target = event.currentTarget;
            let status = target.checked;
            this.$emit('changeAgreeServiceProtocol', {
                status : status
            });
        },
        renewal() {


            this.agreeServiceProtocol = this.isAgreeServiceProtocol

            if(!this.isAgreeServiceProtocol)
            {
                appHelper.showMessage('提示', '请先阅读并同意服务协议');
                return;
            }

            this.pay();
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}
.yellow {
    color: #846130;
}
.gold {
    color: #846130;
}
.red {
    color: #FF6965;
}

</style>
